import { ChangeDetectionStrategy, Component, computed, inject,signal } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SIDEBAR_ITEMS, SIDEBAR_SECONDARY_ITEMS } from '../../../config/sidebar.config';
import Keycloak, { KeycloakLogoutOptions } from 'keycloak-js';
import { HasRolesDirective } from 'keycloak-angular';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { NeadbadgeService } from '../../../services/neadbadge.service';
import { InfoUser } from '../info-user/info-user';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    InfoUser,
    RouterLinkActive,
    HasRolesDirective,
    RouterModule,
    FormsModule,
    NgbCollapseModule,
    NgOptimizedImage
  ],
  templateUrl: './sidebar.html',
  styleUrls: ['./sidebar.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Sidebar  {
  private readonly _sidebarItems = SIDEBAR_ITEMS;
  private readonly _sidebarSecondaryItems = SIDEBAR_SECONDARY_ITEMS;
  public readonly keycloak = inject(Keycloak);
  public readonly neadbadgeService = inject(NeadbadgeService);

  readonly sidebarItems = computed(() => {
    const badges = this.neadbadgeService.badgeData();

    return this._sidebarItems.map(item => {
      if (!item.badge) return item;
      // Logica di mappatura: associa la route alla chiave del service
      let value = 0;
      if (item.route === '/contratti') value = badges.contratti;
      if (item.route === '/documenti') value = badges.documenti;
      if (item.route === '/qualifica') value = badges.qualifiche;
      return { ...item, badgeValue: value };
    });
  });

  readonly sidebarSecondaryItems = signal(this._sidebarSecondaryItems);

 

  getCollapse(item: any): boolean {
    return item.isCollapsed;
  }

  login() {
    this.keycloak.login();
  }

  logout() {
    this.keycloak.logout({
      redirectUri:globalThis.location.origin,
      logoutMethod:'GET'
    }as KeycloakLogoutOptions);
  }

}